import { render, staticRenderFns } from "./RegistroDeDiploma.vue?vue&type=template&id=50eb3842&scoped=true&lang=pug&"
import script from "./RegistroDeDiploma.vue?vue&type=script&lang=js&"
export * from "./RegistroDeDiploma.vue?vue&type=script&lang=js&"
import style0 from "./RegistroDeDiploma.styl?vue&type=style&index=0&id=50eb3842&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eb3842",
  null
  
)

export default component.exports